module.exports = __webpack_public_path__ + "c50c53cad207b8e3d220479d089a829d.png";